'use client'
import { Table, TableRow, TableHeader, TableCell, SmartLink, ColorButton, Pagination, MoreButton } from "@/components/ui";
import { ClientAccountantResponse, PaginationParams } from "@/types";
import React, { useEffect, useState } from "react";
import { Pen, Trash } from "@/assets/icons";
import { listClientsByAccountant } from "@/app/api";

export function ManageClientAccountant({ id }: { id: string }) {
    const [showObservation, setShowObservation] = useState<Record<string, boolean>>({})
    const [clientAccountantsData, setClientAccountantsData] = useState<ClientAccountantResponse>()
    const [filters, setFilters] = useState<PaginationParams>({
        page: 1,
        perPage: 10,
    });

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const data = await listClientsByAccountant(id, filters)
                setClientAccountantsData(data)
            } catch (err) {
                console.log("Erro ao carregar usuários: ", err);
            }
        }

        fetchUsers()
    }, [id, filters]);

    const clientAccountants = clientAccountantsData?.data || []

    const toggleExpand = (visitorId: string) => {
        setShowObservation(prev => ({
            ...prev,
            [visitorId]: !prev[visitorId]
        }))
    }

    const handlePageChange = (page: number) => {
        setFilters({ ...filters, page });
    };

    return (
        <div className="pt-8">
            <div className="flex justify-between">
                <SmartLink type={"internal"} route={"adminAccountantIdClientsIdNew"}
                    params={[`${id}`]}>
                    <ColorButton>Cadastro</ColorButton>
                </SmartLink>
            </div>

            <div className="p-8">
                <div className="hidden md:flex">
                    <Table>
                        <thead>
                            <TableRow>
                                <TableHeader>Código</TableHeader>
                                <TableHeader>Empresa</TableHeader>
                                <TableHeader>Nome</TableHeader>
                                <TableHeader>Status</TableHeader>
                                <TableHeader>Data do Cadastro</TableHeader>
                                <TableHeader>Data da Atualização</TableHeader>
                                <TableHeader></TableHeader>
                            </TableRow>
                        </thead>
                        <tbody>
                            {clientAccountants.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={6} className="text-center items-center">
                                        Não existem clientes para esse contador.
                                    </TableCell>
                                </TableRow>
                            ) : (clientAccountants.map((clientAccountant) => (
                                <React.Fragment key={clientAccountant.id}>
                                    <TableRow>
                                        <TableCell>{clientAccountant.client.code}</TableCell>
                                        <TableCell>{clientAccountant.client.userName}</TableCell>
                                        <TableCell>{clientAccountant.client.name}</TableCell>
                                        <TableCell>
                                            {clientAccountant.client.role === 'CLIENT' ? 'Ativo'
                                                : clientAccountant.client.role === 'INACTIVE' ? 'Inativo'
                                                    : clientAccountant.client.role === 'CANCELED' ? 'Cancelado'
                                                        : '- - - - -'
                                            }
                                        </TableCell>
                                        <TableCell>{new Date(clientAccountant.createdAt).toLocaleDateString()}</TableCell>
                                        {clientAccountant.updatedAt === clientAccountant.createdAt
                                            ?
                                            <TableCell> {"- - - - -"} </TableCell>
                                            :
                                            <TableCell>{new Date(clientAccountant.updatedAt).toLocaleDateString()}</TableCell>
                                        }

                                        <TableCell>
                                            <MoreButton onClick={() => toggleExpand(clientAccountant.id)} />
                                        </TableCell>

                                    </TableRow>

                                    {showObservation[clientAccountant.id] && (
                                        <TableRow>
                                            <TableHeader colSpan={2}>Observação</TableHeader>
                                            <TableCell colSpan={4}>{clientAccountant.observation}</TableCell>
                                            <TableCell className="flex flex-col gap-3">
                                                {clientAccountant.client.role === 'INACTIVE'
                                                    ? ''
                                                    : clientAccountant.client.role === 'CANCELED'
                                                        ? ''
                                                        : <SmartLink type={"internal"} route={"adminAccountantIdClientsIdUpdate"}
                                                            params={[`${id}`, `${clientAccountant.id}`]}>
                                                            <Pen />
                                                        </SmartLink>
                                                }

                                                <SmartLink type={"internal"} route={"adminAccountantIdClientsIdDelete"}
                                                    params={[`${id}`, `${clientAccountant.id}`]}>
                                                    <Trash />
                                                </SmartLink>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </React.Fragment>
                            ))
                            )
                            }
                        </tbody>

                    </Table>
                </div>

                <div className="flex md:hidden">
                    <Table>
                        <tbody>
                            {clientAccountants.length === 0 ? (
                                <TableRow>
                                    <TableCell className="text-center">
                                        Não existem clientes para esse contador.
                                    </TableCell>
                                </TableRow>
                            ) : (clientAccountants.map((clientAccountant) => (
                                <TableRow key={clientAccountant.id}>
                                    <TableHeader>Código</TableHeader>
                                    <TableCell>{clientAccountant.client.code}</TableCell>
                                    <TableHeader>Empresa</TableHeader>
                                    <TableCell>{clientAccountant.client.userName}</TableCell>
                                    <TableHeader>Nome</TableHeader>
                                    <TableCell>{clientAccountant.client.name}</TableCell>
                                    <TableHeader>Status</TableHeader>
                                    <TableCell>
                                        {clientAccountant.client.role === 'CLIENT' ? 'Ativo'
                                            : clientAccountant.client.role === 'INACTIVE' ? 'Inativo'
                                                : clientAccountant.client.role === 'CANCELED' ? 'Cancelado'
                                                    : '- - - - -'
                                        }
                                    </TableCell>
                                    <TableHeader>Data do cadastro</TableHeader>
                                    <TableCell>{new Date(clientAccountant.createdAt).toLocaleDateString()}</TableCell>
                                    <TableHeader>Data da Atualização</TableHeader>
                                    {clientAccountant.updatedAt === clientAccountant.createdAt
                                        ?
                                        <TableCell> {"- - - - -"} </TableCell>
                                        :
                                        <TableCell>{new Date(clientAccountant.updatedAt).toLocaleDateString()}</TableCell>
                                    }

                                    <TableHeader>Observação</TableHeader>
                                    <TableCell>{clientAccountant.observation}</TableCell>
                                    <TableCell className="flex gap-10">
                                        {clientAccountant.client.role === 'INACTIVE'
                                            ? ''
                                            : clientAccountant.client.role === 'CANCELED'
                                                ? ''
                                                : <SmartLink type={"internal"} route={"adminAccountantIdClientsIdUpdate"}
                                                    params={[`${id}`, `${clientAccountant.id}`]}>
                                                    <Pen />
                                                </SmartLink>
                                        }
                                        <SmartLink type={"internal"} route={"adminAccountantIdClientsIdDelete"}
                                            params={[`${id}`, `${clientAccountant.id}`]}>
                                            <Trash />
                                        </SmartLink>
                                    </TableCell>
                                    <TableCell className="border-t-2 min-w-40 border-ochre_accent" />
                                </TableRow>
                            )))}
                        </tbody>
                    </Table>
                </div>
            </div>

            <div>
                {clientAccountantsData?.pagination &&
                    <Pagination
                        currentPage={clientAccountantsData.pagination.page}
                        totalPages={Math.ceil(clientAccountantsData.pagination.total / clientAccountantsData.pagination.perPage)}
                        onPageChange={handlePageChange}
                    />
                }
            </div>
        </div>
    )
}